












































import Vue from 'vue';
import Component from 'vue-class-component';
import ArrowIcon from '@/project/app/client-pages/checkout/ArrowIcon.vue';
import { PageName } from '@/router/routes/constants';
import ImpersonationBanner from '@/project/shared/impersonation/ImpersonationBanner.vue';
import impersonationStore from '@/project/shared/impersonation/impersonation.service';
import serverContextService from '@/core/serverContext.service';

@Component({
    components: { ArrowIcon, ImpersonationBanner }
})
export default class CheckoutHeader extends Vue {
    private get basketLink(): string {
        return PageName.BASKET;
    }

    private get isImpersonating(): boolean {
        return impersonationStore.isImpersonating;
    }

    get isOprema() {
        return serverContextService?.isOprema;
    }

    private get logoDimensions(): {width: string, height: string } {
        return {
            height: '60',
            width: this.isOprema ? '120' : '60'
        };
    }
}
